import { cloneDeep } from 'lodash';
import { setFeedback, delayedClearFeedback } from './feedback';
import { setUrlParams } from './url_params';
const SET_PATH = 'SET_PATH';
const ERROR_PATH = '/error';

const allowedRoutes = [
    '/',
    '/catalog',
    '/search',
    '/contact',
    '/contact-us',
    '/member-services',
    '/privacy-policy',
    '/terms-of-use',
    '/terms-of-membership',
    '/about-us',
    '/how-it-works',
    '/reset-password',
    '/payment',
    '/error'
];

const nonClubRoutes = [
	'/',
	'/payment'
]

const pathInitialState = '';

export default function reducer(state = cloneDeep(pathInitialState), action) {
	switch (action.type) {
		case SET_PATH:
			return action.payload;
		default:
			return state;
	}
}

export function pathInitialize(path){
	return ( dispatch, getState ) => {
		let finalPath = (path && path.length > 0) ? '/' + path : '/';
		let isClub = getState().store.type !== '';

		if(isClub && allowedRoutes.indexOf(finalPath) === -1)
			return dispatch([
				setPath('/catalog'),
				setFeedback('Uh oh, bad link...Back to the homepage.'),
        delayedClearFeedback()
			]);
		else if(!isClub && nonClubRoutes.indexOf(finalPath) === -1 )
			return dispatch([
				setPath('/'),
				setFeedback('Uh oh, bad link...Back to the homepage.'),
        delayedClearFeedback()
			]);
		return dispatch(setPath(finalPath));
	}
}

export function parseLocationPath( sPathname ){
	let finalPath = (sPathname && sPathname.length > 0) ? sPathname : '/';
	let urlParams = [];
	if ( finalPath !== '/' ) {
	  urlParams = sPathname.split('/');
	  // expect aPathSegments[0] to be "" here; remove with array.shift()
	  urlParams.shift();
	  // aPathSegments[0] is now the routing path; capture it for use in state
   	finalPath = '/' + urlParams.shift();
  }
  return [
    setPath( finalPath ),
    setUrlParams( urlParams )
  ]
}


export function setPath(path){
	let finalPath = (path && path.length > 0) ? path : '/';
	return {
		type: SET_PATH,
		payload: finalPath
	}
}

export function setErrorPath(){
	return setPath(ERROR_PATH);
}



// WEBPACK FOOTER //
// ./src/modules/path.js